import { isEmpty, path } from 'ramda'
import { createSelector } from 'reselect'

const getCategories = state => state.omnitecEasymsCategories

export const selectEasymsCategoriesFetching = state => path(['omnitecEasymsCategories', 'isFetching'], state)

export const selectEasymsCategories = createSelector(getCategories, categories => {
    if (!(isEmpty(categories.entities) || isEmpty(categories.result))) {
        const items = categories.entities.omnitecEasymsCategories
        return items
    } else {
        return []
    }
})



// WEBPACK FOOTER //
// ./src/selectors/omnitecSelectors/omnitecEasyms.js